module.exports = __webpack_public_path__ + "img/Kanban.389e86ea.png";